/* eslint-disable @typescript-eslint/no-var-requires */
export default {
  SELECT_AGENCY: {
    config: {
      path: '/select-agency',
      Component: require('view/screens/select-agency/select-agency').default
    }
  }
};
